if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.useGoKwikSliderCart =
          window.rbUseGoKwikSliderCart === true || this.dataset.cartHandler === 'gokwik';

        this.cart = this.useGoKwikSliderCart
          ? null
          : document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (!this.useGoKwikSliderCart && document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.error = false;

        this.submitButton.setAttribute('aria-disabled', true);
        this.setSubmitButtonLoadingText();

        if (this.useGoKwikSliderCart) {
          this.submitButton.classList.add('rb-gokwik-adding');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
          this.dispatchGoKwikCartEvents('open');
        } else {
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner')?.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const linesUpdateDeferred = this.useGoKwikSliderCart
          ? null
          : this.createCartLinesUpdateEvent(variantId, quantity);

        let cartAddSucceeded = false;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));
              this.error = true;

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              return;
            }

            if (this.useGoKwikSliderCart) {
              cartAddSucceeded = true;
              this.publishCartUpdate(response, variantId);
              this.dispatchGoKwikCartEvents('refresh', response);
              this.dispatchGoKwikCartEvents('open', response);
              this.error = false;
              return;
            }

            if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            const resetSubmitButton = () => {
              this.submitButton.classList.remove('loading');
              this.submitButton.classList.remove('rb-gokwik-adding');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner')?.classList.add('hidden');
              this.restoreSubmitButtonText();

              CartPerformance.measureFromEvent("add:user-action", evt);
            };

            if (this.useGoKwikSliderCart && cartAddSucceeded) {
              this.waitForGoKwikCartOpen().then(resetSubmitButton);
            } else {
              resetSubmitButton();
            }
          });
      }

      setSubmitButtonLoadingText() {
        if ((!this.useGoKwikSliderCart && !this.dataset.loadingText) || !this.submitButtonText) return;
        if (!this.submitButton.dataset.originalText) {
          this.submitButton.dataset.originalText = this.submitButtonText.textContent.trim();
        }
        this.submitButtonText.textContent = this.dataset.loadingText || 'Adding';
      }

      restoreSubmitButtonText() {
        if (!this.submitButtonText || !this.submitButton.dataset.originalText) return;
        this.submitButtonText.textContent = this.submitButton.dataset.originalText;
      }

      publishCartUpdate(cartData, variantId) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: variantId,
          cartData,
        });
      }

      dispatchGoKwikCartEvents(action, cartData) {
        const detail = cartData ? { cartData } : {};
        const events =
          action === 'refresh'
            ? ['cart:refresh', 'ajax-cart:refresh', 'cart:update', 'cart:updated']
            : [
                'cart:open',
                'cart-drawer:open',
                'CartDrawer:open',
                'sidebar-cart:open',
                'mini-cart:open',
                'sidecart:open',
                'ajax-cart:open',
              ];

        events.forEach((eventName) => {
          document.dispatchEvent(new CustomEvent(eventName, { detail }));
          window.dispatchEvent(new CustomEvent(eventName, { detail }));
        });
      }

      waitForGoKwikCartOpen(timeout = 30000) {
        return new Promise((resolve) => {
          if (this.isGoKwikCartOpen()) {
            resolve(true);
            return;
          }

          let resolved = false;
          let timer;
          let interval;
          let observer;

          const finish = (opened) => {
            if (resolved) return;
            resolved = true;
            window.clearTimeout(timer);
            window.clearInterval(interval);
            observer?.disconnect();
            resolve(opened);
          };

          observer = new MutationObserver(() => {
            if (this.isGoKwikCartOpen()) finish(true);
          });

          observer.observe(document.body, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['class', 'style', 'open', 'aria-hidden', 'aria-expanded'],
          });

          interval = window.setInterval(() => {
            if (this.isGoKwikCartOpen()) finish(true);
          }, 100);

          timer = window.setTimeout(() => finish(false), timeout);
        });
      }

      isGoKwikCartOpen() {
        const selectors = [
          '#gokwik-cart',
          '#gokwik-cart-root',
          '#gokwik-cart-drawer',
          '#kwik-cart',
          '#kwik-cart-root',
          '#kwik-cart-drawer',
          '#shiprocket-smart-cart-root',
          '[data-app="shiprocket-smart-cart"]',
          '[data-gokwik-cart]',
          '[data-kwik-cart]',
          '.gokwik-cart',
          '.gokwik-cart-drawer',
          '.gokwik-sidecart',
          '.gokwik-slider-cart',
          '.kwik-cart',
          '.kwik-cart-drawer',
          '.kwik-sidecart',
          '.kwik-slider-cart',
          '.shiprocket-smart-cart',
          'iframe[src*="gokwik"]',
          'iframe[src*="kwik"]',
          'iframe[src*="shiprocket"]',
        ];

        return selectors.some((selector) => {
          try {
            return Array.from(document.querySelectorAll(selector)).some((element) =>
              this.isVisibleCartElement(element)
            );
          } catch (error) {
            return false;
          }
        });
      }

      isVisibleCartElement(element) {
        if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;

        const style = window.getComputedStyle(element);
        if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;

        const rect = element.getBoundingClientRect();
        const hasSize = rect.width > 120 && rect.height > 120;
        const inViewport = rect.right > 0 && rect.bottom > 0 && rect.left < window.innerWidth && rect.top < window.innerHeight;

        return hasSize && inViewport;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

